import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "./constants";

const customerService = createApi({
  reducerPath: "customerService",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("admin")
        ? JSON.parse(localStorage.getItem("admin")).token
        : null;
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["Customer"], // Define the tag type
  endpoints: (builder) => ({
    fetchCustomers: builder.query({
      query: ({ page_no }) => `admin/get-all-users?page=${page_no}`,
      providesTags: (result) =>
        result?.data?.data
          ? [
            ...result.data.data.map(({ id }) => ({ type: "Customer", id })),
            { type: "Customer", id: "LIST" },
          ]
          : [{ type: "Customer", id: "LIST" }],
    }),
    addCustomer: builder.mutation({
      query: (formData) => ({
        url: "customers",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "Customer", id: "LIST" }], // Invalidate the customer list
    }),

    editCustomer: builder.mutation({
      query: (formData) => ({
        url: `edit-customer`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [{ type: "Customer", id: "LIST" }], // Invalidate customer list
    }),

    deleteCustomer: builder.mutation({
      query: (id) => ({
        url: `customers/${id}`, // Delete endpoint
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Customer", id: "LIST" }], // Invalidate customer list to refresh data
    }),

    blacklistCustomer: builder.mutation({
      query: (id) => ({
        url: `user/${id}/status`, // Dynamic URL with customer ID
        method: "PATCH",
      }),
      invalidatesTags: (result, error, id) => [{ type: "Customer", id }], // Invalidate only the blacklisted customer
    }),




  }),
});

export const { useFetchCustomersQuery, useAddCustomerMutation,
  useEditCustomerMutation, useDeleteCustomerMutation,
  useBlacklistCustomerMutation
} = customerService;
export default customerService;
